const VECTOR_EXTENSION = '.svg';

function isVectorFilename(filename?: string): boolean {
    if (!filename) {
        return false;
    }

    return filename.trim().toLowerCase().endsWith(VECTOR_EXTENSION);
}

export { isVectorFilename };
